// Progressive MM/DD/YYYY auto-formatter for typed date-of-birth inputs.
//
// The DOB fields use inputMode="numeric" (no "/" on the numeric keypad), so we
// insert the slashes for the user as digits arrive. Reformatting from the digit
// string (rather than the raw value) makes backspace behave naturally: deleting a
// slash just deletes the digit before it on the next keystroke.
//
// Progressive: "10" -> "10", "102" -> "10/2", "1027" -> "10/27",
// "10271976" -> "10/27/1976". Empty stays empty (callers treat "" as "no DOB").
//
// Purely presentational: the produced string matches the MM/DD/YYYY shape the
// existing validators (toIsoDate in CreateTribute, parseTypedDob in ConsentGate)
// already expect — do NOT add validation here.
export const formatDobDigits = (raw: string): string => {
  const digits = raw.replace(/\D/g, "").slice(0, 8); // MMDDYYYY, max 8
  if (digits.length <= 2) return digits;
  if (digits.length <= 4) return `${digits.slice(0, 2)}/${digits.slice(2)}`;
  return `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`;
};
